import log from 'salvo-lite/log'

class ProductPage {
    constructor (theme) {
        this._theme = theme
        this._recentlyViewedLimit = 30
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating', this)
        let handles = localStorage.getItem('ESC_RECENTLY_VIEWED') ? JSON.parse(localStorage.getItem('ESC_RECENTLY_VIEWED')) : []
        let pageHandle = document.querySelector('[data-view-product]').dataset.viewProduct
        if (handles.includes(pageHandle)) {
            return false
        }
        handles.unshift(pageHandle)
        if (handles.length > this._recentlyViewedLimit) {
            handles.slice(0, this._recentlyViewedLimit)
        }
        localStorage.setItem('ESC_RECENTLY_VIEWED', JSON.stringify(handles))
        log.debug(this.constructor.name, 'Initiated', this)
    }
}

export default ProductPage



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Product.js